export default "/img/DashboardLoading.svg"